import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

export const selectConsents = (state:RootState) => state.consents.consents;
export const selectConsent = (state:RootState) => state.consents.consent;
export const selectFilter = (state:RootState) => state.consents.filter;

export const selectFilteredConsents = createSelector(
  selectConsents, selectFilter,
  (items, filter) => {
    if ( !items ) return null;
    const { search } = filter;
    const searchToLower = search.toLowerCase();
    return items.filter(item => {
      return item.name.toLowerCase().indexOf(searchToLower) > -1;
    });
  }
);

export const selectPlatformConsents = createSelector(
  [ selectConsents, (state:RootState, { lng }:{ lng:string }) => lng ],
  (consents, lng) => {
    if ( !consents ) return null;
    return consents.filter(consent => consent.language === lng && consent.platform);
  }
);

export const selectBrandConsents = createSelector(
  [ selectConsents, (state:RootState, { lng }:{ lng:string }) => lng ],
  (consents, lng) => {
    if ( !consents ) return null;
    return consents.filter(consent => consent.language === lng && !consent.platform);
  }
);

export const selectHasConsents = createSelector(
  [ selectConsents, (state:RootState, { lng }:{ lng:string }) => lng ],
  (consents, lng) => {
    if ( !consents ) return false;
    return consents.some(consent => consent.language === lng);
  }
);
